import { supabase } from '../lib/supabase';

export const emailService = {
  // Send lead notification via Supabase Edge Function (Resend)
  async sendLeadNotification(leadData) {
    try {
      const { data, error } = await supabase?.functions?.invoke('send-lead-notification', {
        body: leadData
      });

      if (error) {
        console.error('Edge function error:', error);
        return { success: false, error: error?.message };
      }

      console.log('Lead notification sent successfully:', data);
      return { success: true, data };
    } catch (err) {
      console.error('Failed to send lead notification:', err);
      return { success: false, error: err?.message };
    }
  },
};
